// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 577) return "577.6d00c765b590d4e06f8b.web-dashboard.js";
	if (chunkId === 365) return "365.5c342a404182ba857383.web-dashboard.js";
	// return url for filenames based on template
	return undefined;
};